import { backendApi } from "./axios";
import { INSTITUTE_ENDPOINTS } from "./endpoints";

export function getTutors() {
  return backendApi.get(INSTITUTE_ENDPOINTS.GET_TUTORS);
}

export function createTutor(data) {
  return backendApi.post(INSTITUTE_ENDPOINTS.CREATE_TUTORS, data);
}

export function updateInstitute(data) {
  return backendApi.put(INSTITUTE_ENDPOINTS.UPDATE_ACCOUNT, data);
}

export function updateUsername(data) {
  return backendApi.put(INSTITUTE_ENDPOINTS.UPDATE_USERNAME, data);
}

export function fetchInstituteProfile() {
  return backendApi.get(INSTITUTE_ENDPOINTS.GET_PROFILE);
}

export function getStudents() {
  return backendApi.get(INSTITUTE_ENDPOINTS.GET_STUDENTS);
}

export function createStudent(data) {
  return backendApi.post(INSTITUTE_ENDPOINTS.CREATE_STUDENT, data);
}

export function preDeleteCheck() {
  return backendApi.get(INSTITUTE_ENDPOINTS.PRE_DELETE_CHECK);
}

export function deleteAccount(payload) {
  return backendApi.post(INSTITUTE_ENDPOINTS.DELETE_ACCOUNT, payload);
}

export function getPendingTutors(params) {
  return backendApi.get(INSTITUTE_ENDPOINTS.GET_PENDING_TUTORS, { params });
}

export function getpendingStudents(params) {
  return backendApi.get(INSTITUTE_ENDPOINTS.GET_PENDING_STUDENTS, { params });
}

export function deletePendingTutor(tutorId) {
  return backendApi.delete(INSTITUTE_ENDPOINTS.DELETE_PENDING_TUTOR.replace(":tutorId", tutorId));
}

export function deletePendingStudent(studentId) {
  return backendApi.delete(INSTITUTE_ENDPOINTS.DELETE_PENDING_STUDENT.replace(":studentId", studentId));
}